import requestApi from "@/utils/requestApi";
import { uuid } from "@/utils/utils";

export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isFixed: {
      type: Boolean,
      default: true,
    },
    checked: {
      type: Boolean,
      default: true,
    },
    indeterminate: {
      type: Boolean,
      default: false,
    },
    checkedDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      total: 0,
      amount: 0,
      submitDisabled: true,
      discountAmount: 0,
    };
  },
  watch: {
    list: {
      handler: function (data) {
        const goodsList = [];
        data.forEach((item) => {
          item.carItemList.forEach((goods) => {
            if (goods.upDownStatus && goods.currPrice && goods.originalPrice && goods.checked) {
              goodsList.push(goods);
            }
          });
        });
        if (goodsList.length) {
          this.submitDisabled = false;
        } else {
          this.submitDisabled = true;
        }
        this.total = goodsList.length;
        this.amount = goodsList.reduce((cur, item) => {
          return (Number(cur) + Number(item.currPrice) * Number(item.quantity)).toFixed(2);
        }, 0);
        this.discountAmount = goodsList.reduce((cur, item) => {
          return (Number(cur) + (Number(item.originalPrice) - Number(item.currPrice)) * Number(item.quantity)).toFixed(2);
        }, 0);
      },
      deep: true,
    },
  },
  methods: {
    /* 删除 */
    del() {
      const normalGoods = [];
      this.list.forEach((item) => {
        item.carItemList.forEach((goods) => {
          if (goods.upDownStatus && goods.currPrice && goods.originalPrice) {
            normalGoods.push(goods);
          }
        });
      });

      if (!normalGoods.length || normalGoods.every((item) => !item.checked)) {
        this.$message.warning("请先选择要删除的商品");
        return;
      }

      this.$confirm("您确定要删除已选的商品吗？", "提示", {
        type: "warning",
      }).then(async () => {
        const loading = this.$loading({
          lock: false,
          text: "删除中...",
        });
        const skuIdList = normalGoods.filter((item) => item.checked).map((item) => item.skuId);
        const { exception, code } = await requestApi.post("sctrading/shoppingCart/deleteGoods", {
          skuIdList,
        });

        if (code == "0") {
          this.$message({
            type: "success",
            message: "删除成功",
          });

          this.$emit("update:checked", false);
          this.$emit("loadData");
        } else {
          this.$message({
            type: "error",
            message: exception,
          });
        }

        loading.close();
      });
    },

    /* 收藏 */
    async favorite() {
      let arr = [];
      this.list.forEach((item) => {
        item.carItemList.forEach((goods) => {
          if (goods.checked && !goods.disabled) {
            arr.push({
              goodsId: goods.spuId,
              shopId: goods.shopId,
            });
          }
        });
      });

      if (!arr.length) {
        this.$message.warning("请先选择要收藏的商品");
        return;
      }

      const loading = this.$loading({
        lock: false,
        text: "收藏中...",
      });

      const { msg, code } = await requestApi.post("scbasic/member/memberfavorite/add", {
        goodsFavoriteList: arr,
      });

      if (code == "0") {
        this.$message({
          type: "success",
          message: "收藏成功",
        });
      } else {
        this.$message({
          type: "error",
          message: msg,
        });
      }

      loading.close();
    },

    /* 清空全部失效商品 */
    clearDisabled() {
      const invalidGoods = [];
      this.list.forEach((item) => {
        item.carItemList.forEach((goods) => {
          if (!goods.upDownStatus) {
            invalidGoods.push(goods);
          }
        });
      });

      if (!invalidGoods.length) {
        this.$message.warning("失效商品已全部删除");
        return;
      }

      this.$confirm("您确定要清空失效商品吗？", "提示", {
        type: "warning",
      }).then(async () => {
        const loading = this.$loading({
          lock: false,
          text: "删除中...",
        });
        const skuIdList = invalidGoods.map((item) => item.skuId);
        const { exception, code } = await requestApi.post("sctrading/shoppingCart/deleteGoods", {
          skuIdList,
        });

        if (code == "0") {
          this.$message({
            type: "success",
            message: "清空成功",
          });
          this.$emit("loadData");
        } else {
          this.$message({
            type: "error",
            message: exception,
          });
        }

        loading.close();
      });
    },

    /* 全选 */
    checkboxChange(checkbox) {
      this.$emit("checkboxChang", checkbox);
    },

    /* 去结算 */
    async cartSubmit() {
      let cartItemReqFormList = [];
      let cartItemReqFormListAll = [];
      // 是否包含应用市场商品
      let markGoodsNum = 0;
      let markGoodsName = "";
      this.list.forEach((item) => {
        item.carItemList.forEach((goods) => {
          if (goods.checked && !goods.disabled && goods.currPrice) {
            if (goods.axisStr && goods.axisStr.indexOf("$4616$") > -1) {
              markGoodsNum += 1;
              markGoodsName = goods.skuName;
              return;
            }
            cartItemReqFormList.push({
              fromShopId: goods.fromShopId,
              fundShopId: goods.fromShopId,
              goodsId: goods.skuId,
              goodsQuantity: goods.quantity,
              skuId: goods.skuId,
              quantity: goods.quantity,
            });
            cartItemReqFormListAll.push(goods);
          }
        });
      });

      console.log("arr", cartItemReqFormList);
      if (markGoodsNum != 0) {
        this.$message.warning(`商品${markGoodsName}无法在购物车中结算，请在商品详情页直接购买`);
        return;
      }
      if (!cartItemReqFormList.length) {
        this.$message.warning("请先选择商品");
        return;
      }

      const minOrderQuantityList = cartItemReqFormListAll.filter((item) => item.minOrderQuantity && Number(item.quantity) < item.minOrderQuantity);
      if (minOrderQuantityList.length) {
        this.$message.warning(`商品【${minOrderQuantityList[0].skuName}】起订量不满足`);
        return;
      }

      const loading = this.$loading({
        lock: false,
        text: "提交中...",
      });

      const { exception, code } = await requestApi.post("sctrading/order/confirm", {
        sources: 0,
        cartItemReqFormList: cartItemReqFormList.map((item) => ({
          fromShopId: item.fromShopId,
          quantity: item.quantity,
          skuId: item.skuId,
        })),
      });

      if (code == "0") {
        const subkey = {
          sources: 0,
          cartItemReqFormList: JSON.stringify(cartItemReqFormList),
        };

        const uuidStr = uuid();
        sessionStorage.setItem(uuidStr, JSON.stringify(subkey));
        console.log(uuidStr);
        window.location.href = `${process.env.VUE_APP_APP}v2/order/buyer/orderSubmit?subkey=${uuidStr}`;
      } else {
        this.$message({
          type: "error",
          message: exception,
        });
      }

      loading.close();
    },
  },
};
